exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".AYLuP {\n  padding: 5px 10px;\n  font-size: 12px;\n  overflow: visible;\n  height: 68px;\n  border-radius: 10px;\n  border: 1px solid #aaa;\n}\n.AYLuP table {\n  width: 100%;\n}\n.AYLuP table thead th {\n  text-align: left;\n  width: 33%;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "AYLuP"
};